export default __webpack_public_path__ + "static/media/8.35200f4d.mp3";